export default __webpack_public_path__ + "static/N0279-d2961f605dd8818e0843978050598916.png";